import { useSelector } from 'react-redux';

import { priceTitleSelector } from '@zoopla/redux-reducer-filters';
import { SearchType } from '@zoopla/listing-search-context';
import { useSearchType } from './useSearchType';

export const useSelectPriceTitle = () => {
    const searchType = useSearchType();
    const { forSale, toRent } = useSelector(priceTitleSelector);

    return searchType === SearchType.ForSale ? forSale : toRent;
};
